var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apps"},[_c('Guide',{attrs:{"template":_vm.$t('app.list.guide'),"size":"big"}}),_c('Note',[_vm._v(" "+_vm._s(_vm.$t('app.list.note'))+" ")]),_c('div',{staticClass:"shortcuts"},_vm._l((_vm.apps),function(app,idx){return _c('AppShortcut',_vm._b({key:idx,attrs:{"to":`https://${app.host}`}},'AppShortcut',app,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }